import { useEffect, useState } from "react";
import api from "../utils/api";

export default function CronActivities() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const itemsPerPage = 10;

  const fetchActivities = async (page = 1, q = "") => {
    setLoading(true);
    try {
      const res = await api.get("/cron-activities", {
        params: {
          page,
          limit: itemsPerPage,
          q,
        },
        withCredentials: true,
      });

      setActivities(res.data.activities || []);
      if (res.data.pagination) {
        setTotalPages(res.data.pagination.totalPages || 1);
      }
    } catch (err) {
      console.error("Error fetching cron activities:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setSearch(searchInput);
  };

  const handleClearDate = () => {
    setSearchInput("");
    setCurrentPage(1);
    setSearch("");
  };

  useEffect(() => {
    fetchActivities(currentPage, search);
  }, [currentPage, search]);

  const getStatusBadge = (status) => {
    if (status === "success") {
      return (
        <span className="bg-green-100 text-green-700 px-3 py-2 rounded-full text-xs font-semibold">
          Success
        </span>
      );
    }
    return (
      <span className="bg-red-100 text-red-700 px-3 py-1 rounded-lg text-xs font-semibold">
        Failed
      </span>
    );
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mt-10 ml-2 mb-3">Cron List</h1>

      <div className="m-2 bg-white rounded-md shadow-lg p-5">
        <div className="mb-4 flex justify-end gap-2">
          <input
            type="date"
            value={searchInput}
            onChange={(e) => {
              setSearchInput(e.target.value);
            }}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleSearch}
            className="px-4 py-2 bg-blue-500 text-white font-medium rounded-lg hover:bg-blue-600 transition"
          >
            Search
          </button>
          <button
            onClick={handleClearDate}
            className="px-4 py-2 bg-gray-500 text-white font-medium rounded-lg hover:bg-gray-600 transition"
          >
            Clear
          </button>
        </div>
        <table className="w-full text-sm border-separate border-spacing-y-2">
          <thead>
            <tr className="bg-slate-100 text-slate-600">
              <th className="px-4 py-3 text-left rounded-tl-xl rounded-bl-xl">
                Job Name
              </th>
              <th className="px-4 py-3 text-center">Status</th>
              <th className="px-4 py-3 text-center">Message</th>
              {/* <th className="px-4 py-3 text-center">Executed At</th> */}
              <th className="px-4 py-3 text-right rounded-tr-xl rounded-br-xl">
                Executed At
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="text-center py-4">
                  Loading activities...
                </td>
              </tr>
            ) : activities.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-4">
                  No cron activities found.
                </td>
              </tr>
            ) : (
              activities.map((activity) => (
                <tr
                  key={activity._id}
                  className="border-t transition hover:bg-slate-100"
                >
                  <td className="px-4 py-4 font-medium">{activity.jobName}</td>
                  <td className="px-4 py-4 text-center">
                    {getStatusBadge(activity.status)}
                  </td>
                  <td className="px-4 py-4 text-center text-gray-700">
                    {activity.message}
                  </td>
                  <td className="px-4 py-4 text-right">
                    {new Date(activity.executedAt).toLocaleString("en-GB")}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-2 mt-4">
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Prev
            </button>
            <span className="px-3 py-1 font-medium">
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
